<!--站点/管理页 价格数据表-->
<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="priceData"
            hide-default-footer
            disable-sort
            :dark="theme.tableDark"
            :items-per-page="50"
        >
            <template v-slot:item.startTime="{ item }">
                {{ item.startTime }}
            </template>
            <template v-slot:item.time="{ item }">
                <el-input
                    v-if="!disabled"
                    :disabled="disabled"
                    v-model="item.time"
                    @blur="blur(item)"
                ></el-input>
                <div v-if="disabled">{{ item.time }}</div>
            </template>
            <template v-slot:item.elec_price="{ item }">
                <el-input
                    v-if="!disabled"
                    :disabled="disabled"
                    v-model="item.elec_price"
                ></el-input>
                <div v-if="disabled">{{ item.elec_price }}</div>
            </template>
            <template v-slot:item.sevice_price="{ item }">
                <el-input
                    v-if="!disabled"
                    :disabled="disabled"
                    v-model="item.sevice_price"
                ></el-input>
                <div v-if="disabled">{{ item.sevice_price }}</div>
            </template>
            <template v-slot:item.add="{ item }" v-if="!disabled">
                <i class="el-icon-plus" @click="addSite(item)"></i>
            </template>
            <template v-slot:item.delete="{ item }" v-if="!disabled">
                <i v-if="item != priceData[0]" class="el-icon-minus" @click="deleteSite(item)"></i>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    data() {
        return {
            headers: [],
            priceData: [], //价格表中的数据
        };
    },
    props: {
        applyPrice: Array,
        disabled: Boolean,
    },
    computed: {
        ...mapState(["theme"]),
    },
    mounted() {
        this.priceDataF();
        if (!this.disabled) {
            this.headers = [
                { text: "开始时间(0-24h)", value: "startTime" },
                { text: "结束时间(0-24h)", value: "time" },
                { text: "电费(元)", value: "elec_price" },
                { text: "服务费(元)", value: "sevice_price" },
                { text: "增加", value: "add" },
                { text: "删除", value: "delete" },
            ];
        } else {
            this.headers = [
                { text: "开始时间(0-24h)", value: "startTime" },
                { text: "结束时间(0-24h)", value: "time" },
                { text: "电费(元)", value: "elec_price" },
                { text: "服务费(元)", value: "sevice_price" },
            ];
        }
    },
    watch: {
        priceData: {
            handler(val) {
                let data = this.JsonData(val);
                val.forEach((item, index) => {
                    if (index == 0 && item.time != 0) {
                        val[index].startTime = 0;
                    } else if (item.time == item.startTime && item.time != 24) {
                        val[index].time = null;
                    } else {
                        val[index].startTime = val[index - 1].time;
                    }
                });
                this.modifyPrice();
            },
            deep: true,
        },
        disabled: {
            handler(val) {},
            deep: true,
        },
    },
    methods: {
        /*对表格数据赋值*/
        priceDataF() {
            this.priceData = this.JsonData(this.applyPrice);
            if (this.priceData.length == 0) {
                this.priceData = [{ time: 24, elec_price: 0.7, sevice_price: 0.3 }];
            } else if (this.priceData[0].time == 0 && this.priceData.length == 1) {
                this.priceData = [
                    {
                        time: 24,
                        elec_price: this.priceData[0].elec_price,
                        sevice_price: this.priceData[0].sevice_price,
                    },
                ];
            } else if (this.priceData[0].time == 0 && this.priceData.length > 1) {
                this.priceData[0] = {};
            } else if (this.priceData[this.priceData.length - 1].time != 24) {
                // this.priceData.push({ time: 24, elec_price: 70, sevice_price: 30 });
                this.priceData[this.priceData.length - 1].time = 24;
            }
            for (let i = 0; i < this.priceData.length; i++) {
                // if (String(this.priceData[i].elec_price).indexOf(".")) {
                //     this.priceData[i].elec_price = this.priceData[i].elec_price * 100;
                //     this.priceData[i].elec_price = this.priceData[i].elec_price / 10000;
                // } else {
                //     this.priceData[i].elec_price = this.priceData[i].elec_price / 100;
                // }
                // if (String(this.priceData[i].sevice_price).indexOf(".")) {
                //     this.priceData[i].sevice_price = this.priceData[i].sevice_price * 100;
                //     this.priceData[i].sevice_price = this.priceData[i].sevice_price / 10000;
                // } else {
                //     this.priceData[i].sevice_price = this.priceData[i].sevice_price / 100;
                // }
                this.priceData[i].elec_price = this.dealPrice(this.priceData[i].elec_price);
                this.priceData[i].sevice_price = this.dealPrice(this.priceData[i].sevice_price);
            }
        },
        /*添加一列金额*/
        addSite(item) {
            let data = this.JsonData(this.priceData);
            let index;
            data.forEach((val, i) => {
                if (item.time == val.time) {
                    index = i;
                }
            });
            this.priceData.splice(index + 1, 0, { time: 24, elec_price: 0.7, sevice_price: 0.3 });
        },
        /*删除当前列时间金额*/
        deleteSite(item) {
            let data = this.JsonData(this.priceData);
            let index;
            data.forEach((val, i) => {
                if (item.time == val.time) {
                    index = i;
                }
            });
            this.priceData.splice(index, 1);
        },
        /*输入时间验证*/
        blur(item) {
            if (Number(item.time) <= Number(item.startTime)) {
                this.$message.error("结束时间不能小于开始时间");
            }
            if (item.time > 24 || item.time < 0) {
                this.$message.error("结束时间不能超出范围");
            }
            for (let i = 0; i < this.priceData.length; i++) {
                if (
                    i != this.priceData.length - 1 &&
                    Number(this.priceData[i].startTime) > Number(this.priceData[i].time)
                ) {
                    this.priceData[i].time = null;
                }
            }
        },
        /*修改价格*/
        modifyPrice() {
            let data = this.JsonData(this.priceData);
            let price = [];
            for (let i = 0; i < data.length; i++) {
                price[i] = {};
                price[i].time = Number(data[i].time);
                price[i].elec_price = this.multiplyBy(data[i].elec_price, 100);
                price[i].sevice_price = this.multiplyBy(data[i].sevice_price, 100);
            }
            if (price[data.length - 1].time == 0) {
                price[data.length - 1].time = 24;
            }
            this.$emit("modify", price);
        },
        JsonData(data) {
            return JSON.parse(JSON.stringify(data));
        },
        //处理价格为小数出现精度错误
        dealPrice(price) {
            if (String(price).indexOf(".")) {
                let y = String(price).indexOf(".") + 1; //获取小数点的位置
                let count = String(price).length - y; //获取小数点后的个数
                let data = price * count * 10;
                return data / (count * 1000);
            } else {
                return price / 100;
            }
        },
        //乘
        multiplyBy(arg1, arg2) {
            var m = 0,
                s1 = arg1.toString(),
                s2 = arg2.toString();
            try {
                m += s1.split(".")[1].length;
            } catch (e) {}
            try {
                m += s2.split(".")[1].length;
            } catch (e) {}
            return (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) / Math.pow(10, m);
        },
    },
};
</script>
